module.exports = __webpack_public_path__ + "static/gm-45-50020e9db1c606a0191f79e187d78d63.jpg";